/**************************************************
 * Nombre:       Formulario_Contenido_Test_Preguntas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {CheckCircle, Delete} from '@mui/icons-material'
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";

const Formulario_Contenido_Test_Preguntas = ({...props}) => {
    const [respuestas, setRespuestass] = useState([]);

    const agregar = () => {
        let opcion = props.props.getValues('opcion');
        let opciones = props.props.getValues('opciones');
        if (opcion) {
            let arr = []
            if (opciones) {
                arr = opciones
            }
            arr.push(opcion);
            props.props.setValue('opcion', '')
            props.props.setValue('opciones', arr)
        }
    }

    const borrar = (index) => {

        let opciones = props.props.getValues('opciones');
        let arr = opciones
        arr.splice(index, 1);
        props.props.setValue('opciones', arr)

    }

    const obtenerOpciones = (ops) => {

        let arr = []
        for (let i = 0; i < ops.length; i++) {
            arr.push(i + 1)
        }

        return arr

    }

    useEffect(() => {

        let ops = props.props.getValues('opciones');
        if (ops && ops.length > 0) {
            setRespuestass(ops);
        }


    }, [props.props.watch('opciones')])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={4} nombre={'Pregunta'} dato={'pregunta'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Respuestas</Typography>
                </Grid>

                <Grid container size={9} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={2} nombre={'Opcion de respuesta'} dato={'opcion'} {...props}

                    />
                </Grid>

                <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                    <Button
                        onClick={() => agregar()}
                    >Agregar</Button>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {respuestas.map((it, index) => {
                        return (

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={10}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, py: 1}}>
                                    <Typography><span style={{paddingRight: 5}}>{index + 1}.</span>{it}</Typography>
                                </Grid>

                                <Grid container size={2} sx={{justifyContent: 'flex-end'}}>
                                    <IconButton
                                        onClick={() => borrar(index)}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </Grid>

                            </Grid>

                        )
                    })}

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Respuesta correcta</Typography>
                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={CheckCircle} nombre={'Opcion correcta'} dato={'correcta'} {...props}
                                   opciones={obtenerOpciones(respuestas)}
                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Contenido_Test_Preguntas